import * as React from 'react';
import type { Equipment, UpdateEquipmentPayload as Payload } from 'contracts/temperature-control/equipments';
import { api, handleApiError, applyQueryString } from 'services/api';

export const useUpdateEquipment = () => {
  const updateEquipment = React.useCallback(async (payload: Payload) => {
    try {
      const { data } = await api.put<Equipment>(`equipments/${payload.id}`, payload.data);
      return data;
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return { updateEquipment };
};